var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto mb-8 py-6 px-2 px-sm-10 d-flex flex-column justify-space-between align-center",attrs:{"elevation":"3"}},[_c('InitialEstimatedRate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }